// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Dialog_mainContainer__2GKuB","dialogButton":"Dialog_dialogButton__38jlQ","dialogTitle":"Dialog_dialogTitle__VQk6V","dialogContent":"Dialog_dialogContent__3CdJ4"};